// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__13SqH","selected":"Chip_selected__1yuT0"};